import { useMemo } from "react"

import { useRoutes } from "react-router-dom"

import { DetailSegmentSelectListener, SegmentSelectListener } from "@l2r-front/l2r-common"
import { MapAdapterBoundingBox, MapAdapterRoad } from "@l2r-front/l2r-networks"
import { NavigateWithParams, useUrlParams } from "@l2r-front/l2r-utils"

import { RiskZoneSelectListener } from "../../containers/RiskZoneSelectListener/RiskZoneSelectListener"

import { RiskZoneValidator } from "../RiskZoneValidator"

export const RiskZonesDesktopRoutes = () => {
    const { getParams } = useUrlParams()
    const searchParams = getParams()

    const riskZonesRoutes = useMemo(() => {
        return [
            {
                path: "/*",
                element: <>
                    <MapAdapterBoundingBox />
                    <SegmentSelectListener />
                </>,
            },
            {
                path: "/:road",
                element: <>
                    <MapAdapterRoad />
                    <DetailSegmentSelectListener />
                </>,
            },
            {
                path: "/:road/:riskZoneId",
                element: <RiskZoneValidator>
                    <RiskZoneSelectListener />
                </RiskZoneValidator>,
            },
            {
                path: "/:road/*",
                element: <NavigateWithParams replace to={`../:road?${searchParams}`} />,
            },
        ]
    }, [searchParams])

    return useRoutes(riskZonesRoutes)
}